import React from 'react';
import AppRoutes from '@/routes';
import MainLayout from '@/components/Layout/MainLayout';

/**
 * Main App component that sets up the layout and routing
 *
 * This component is used by:
 * - main.tsx for local development (with BrowserRouter)
 * - single-spa.tsx for microfrontend integration (with MemoryRouter)
 *
 * The ThemeProvider, CssBaseline, and Router are provided by the parent components
 * to allow flexibility between local development and single-spa integration.
 */
const App: React.FC = () => {
  return (
    <MainLayout>
      <AppRoutes />
    </MainLayout>
  );
};

export default App;
